<template>
  <page>
    <module style="background: #F5F5F5">
      <div class="dispute-state flex-column">
        <h1>状态：{{disputeStateName[disputeInfo.state]}}</h1>
        <div class="info-content">
          <h5>申请时间：{{disputeInfo.create_date}}</h5>
          <h5 v-if="disputeInfo.state==2">处理时间：{{disputeInfo.plat_process_date}}</h5>
          <h5 v-if="disputeInfo.state==3">撤销时间：{{disputeInfo.cancel_date}}</h5>
        </div>
      </div>
      <div class="dispute-info flex-row">
        <!-- 关联订单信息 -->
        <div class="info-section">
          <dl class="order-info">
            <dt class="flex-between-center">
              <p>关联订单：{{orderInfo.order_number || orderInfo.order_number}}</p>
              <c-button height="26" color="gray" hollow @click="clipboard(orderInfo.order_number || orderInfo.order_number)">复制</c-button>
            </dt>
            <dd>
              <div class="order-info-item flex">
                <label>订单状态：</label>
                <p>
                  {{orderState}}
                </p>
              </div>
              <div class="order-info-item flex">
                <label>买家账号：</label>
                 <c-image v-if="orderInfo.head_photo" :src="orderInfo.head_photo" size="30" preview></c-image>
                 <div class="flex-between-center" style="margin-left: 10px">{{ orderInfo.nick_name ? orderInfo.nick_name : '--' }} {{ orderInfo.user_manage_mobilephone ? orderInfo.user_manage_mobilephone : '--' }}</div>
              </div>
              <div class="order-info-item flex" >
                <label>下单时间：</label>
                <p>{{orderInfo.create_date}}</p>
              </div>
              <div class="order-info-item flex" >
                <label>已支付：</label>
                <p>￥{{orderInfo.payment_money}}</p>
              </div>
              <div class="order-info-item flex" >
                <label>所属商家：</label>
                <p>{{ orderInfo.stationed_name }}</p>
              </div>
            </dd>
          </dl>

          <c-table style="margin-top:30px;" v-model="orderInfo.productList" height="auto" :paging="false" border v-if="orderInfo">
            <c-table-column
                label="服务信息"
                width="100"
            >
              <template v-slot="{data}">
                <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                              :name="data.product_itemnumber + ' - '+data.product_name"
                              image-size="30"></product-info>
                <product-info v-else :image="data.product_img_url" :name="data.product_name"
                              image-size="30"></product-info>
              </template>
            </c-table-column>
            <c-table-column
                label="成交单价"
            >
              <template v-slot="{data}">
                            <span v-if="orderInfo.order_state == 0 && !data.product_unit_price" style="color:brown">
                                待报价
                            </span>
                <span v-else>
                                 <span v-if="orderInfo.order_type == 2">
                                    ￥{{parseFloat(data.product_unit_price||0).toFixed(2)}}
                                    + {{data.points}}积分
                                </span>
                                <span v-else>
                                   ￥{{parseFloat(data.product_unit_price).toFixed(2)}}
                                </span>
                                <font style="text-decoration: line-through;color:#999999;" v-if="data.product_unit_price!=data.original_product_price">
                                    <br/>
                                    ￥{{ parseFloat(data.original_product_price).toFixed(2)}}
                                </font>
                            </span>
              </template>
            </c-table-column>

            <c-table-column
                label="数量"
                width="80"
            >
              <template v-slot="{data}">
                ×{{ data.product_count }}
              </template>
            </c-table-column>

            <c-table-column
                label="折扣率"
                width="70"
                v-if="orderInfo.order_type != 2"
            >
              <template v-slot="{data}">
                            <span v-if="orderInfo.order_state == 0">
                                --
                            </span>
                <span v-else>
                                 {{ parseFloat(data.product_unit_price * data.product_count * 100 / data.original_product_money).toFixed(2) }}%
                            </span>
              </template>
            </c-table-column>

            <c-table-column
                label="服务总额"
            >
              <template v-slot="{data}">
                             <span v-if="orderInfo.order_state == 0 && !data.product_money" style="color:brown">
                                待报价
                            </span>
                <span v-else>
                                <span v-if="orderInfo.order_type == 2">
                                    ￥{{parseFloat(data.product_money||0).toFixed(2)}}
                                    +{{parseFloat(data.points)*parseFloat(data.product_count)}}积分
                                </span>
                                <span v-else>
                                    ￥{{parseFloat(data.product_money).toFixed(2)}}
                                </span>

                                <font style="text-decoration: line-through;color:#999999;"  v-if="data.product_money!=data.original_product_money">
                                    <br/>￥ {{parseFloat(data.original_product_money).toFixed(2)}}
                                </font>
                            </span>
              </template>
            </c-table-column>
          </c-table>
          <div class="order-total flex-between-center">
            <div v-if="orderInfo.order_state != 0">
              ￥{{ parseFloat(orderInfo.product_money).toFixed(2) }}（订单金额）
              <span v-if="orderInfo.order_type==7">
                            +  ￥{{ parseFloat(cusTomInfo.product_price_money).toFixed(2) }}(定制费用)
                        </span>
              <span v-if="orderInfo.logistics_money && orderInfo.logistics_money > 0">
                            +  ￥{{ parseFloat(orderInfo.logistics_money).toFixed(2) }}(运费)
                        </span>
              <span v-if="orderInfo.order_type == 2" style="color: magenta">
                            + {{orderInfo.points}} 积分
                        </span>
              <span v-if="orderInfo.total_fee_money && orderInfo.total_fee_money > 0">
                            + ￥{{ parseFloat(orderInfo.total_fee_money).toFixed(2) }}(其他费用)
                        </span>
            </div>
            <div v-if="orderInfo.order_state != 0">
              {{ orderInfo.payment_state == 1 ? '应付' : '已付' }}金额：<span><b>￥{{ paymentTotal }}</b></span>
              <span v-if="orderInfo.order_type == 2" style="font-size: 16px;color: magenta">
                            + {{orderInfo.points}} 积分
                        </span>
              <dd v-if="orderInfo.payment_state == 2 && orderInfo.order_state != 5 && orderInfo.order_state != 6">待付尾款：<b>￥{{(parseFloat(orderInfo.product_money) - paymentTotal).toFixed(2)}}</b></dd>
            </div>
          </div>
          <dt class="dt">
            订单服务更新记录
          </dt>
          <c-table v-model="orderInfo.order_history_list" height="auto" :paging="false" border v-if="orderInfo.order_history_list">
            <c-table-column
                label="时间"
                width="40"
            >
              <template v-slot="{data}">
                {{data.create_date}}
              </template>
            </c-table-column>

            <c-table-column
                label="操作人"
                width="20"
            >
              <template v-slot="{data}">
				            <span style="color:blue;">
				                【{{userTypeName[data.user_type]}}】
				            </span>
                <span v-if="data.user_type == 1 || data.user_type == 2 || data.user_type == 3">
				                {{data.nick_name||'-'}}({{data.user_manage_mobilephone}})
				            </span>
                <span v-if="data.user_type == 4 || data.user_type == 99">
				                {{data.user_realname||'-'}}
				            </span>
              </template>
            </c-table-column>

            <c-table-column
                label="备注"
                width="50"
            >
              <template v-slot="{data}">
                {{data.remark}}
              </template>
            </c-table-column>

            <c-table-column
                label="附件"
                width="20"
            >
              <template v-slot="{data}">
                <a style="color:blue;" v-if="data.file_url" :href="data.file_url" target="_blank" class="nav-more">
                  下载
                </a>
              </template>
            </c-table-column>
          </c-table>
        </div>
        <div name="divide" style="width: 10px;background: #F5F5F5"></div>
        <!-- 关联售后单信息 -->
        <div class="info-section">
          <dl class="order-info">
            <dt class="flex-between-center">
              <p>关联售后单：{{refundInfo.base_info.refund_number}}</p>
              <c-button height="26" color="gray" hollow @click="clipboard(refundInfo.base_info.refund_number)">复制</c-button>
            </dt>
            <dd>

              <div class="order-info-item flex">
                <label>售后状态：</label>
                <p>
                  {{refundStateName[refundInfo.base_info.state]}}
                </p>
              </div>
              <div class="order-info-item flex" >
                <label>所属商家：</label>
                <p>{{ refundInfo.order_info.stationed_name }}</p>
              </div>
              <div class="order-info-item flex">
                <label>申请人：</label>
                <p>
                  {{ refundInfo.order_info.nick_name ? refundInfo.order_info.nick_name : '--' }}
                </p>
              </div>
              <div class="order-info-item flex" >
                <label>申请时间：</label>
                <p>{{refundInfo.base_info.create_date}}</p>
              </div>
              <div class="order-info-item flex" >
                <label>申请退款：</label>
                <p>￥{{refundInfo.base_info.refund_total_money}}</p>
              </div>
              <div class="order-info-item flex" >
                <label>退款原因：</label>
                <p>{{refundInfo.base_info.refund_reason}}</p>
              </div>
              <div class="order-info-item flex" v-if="refundInfo.base_info.state==3">
                <label>驳回时间：</label>
                <p>{{refundInfo.base_info.audit_date}}</p>
              </div>
              <div class="order-info-item flex" v-if="refundInfo.base_info.state==3">
                <label>驳回原因：</label>
                <p>{{refundInfo.base_info.audit_reject_reason}}</p>
              </div>

            </dd>
          </dl>

          <c-table style="margin-top: 20px;" v-model="refundInfo.product_info" height="auto" :paging="false" border v-if="refundInfo">
            <c-table-column
                label="服务信息"
                width="300"
            >
              <template v-slot="{data}">
                <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                              :name="data.product_itemnumber + ' - '+data.product_name"
                              image-size="30"></product-info>
                <product-info v-else :image="data.product_img_url" :name="data.product_name"
                              image-size="30"></product-info>
              </template>
            </c-table-column>

            <c-table-column label="退款金额">
              <template v-slot="{data}">
                  <span >
                      ￥{{parseFloat(data.product_money).toFixed(2)}}
                  </span>
              </template>
            </c-table-column>
          </c-table>

          <dt class="dt">
            协商历史
          </dt>
          <c-table style="margin-top: 20px;" v-model="refundInfo.process_history_list" height="auto" :paging="false" border v-if="refundInfo">
            <c-table-column label="操作人" width="20">
              <template v-slot="{data}">
              <span v-if="data.type==1">
                买家
              </span>
              <span v-else>
                卖家
              </span>
              </template>
            </c-table-column>

            <c-table-column label="操作时间" width="40" >
              <template v-slot="{data}">
                {{data.create_date}}
              </template>
            </c-table-column>
            <c-table-column label="协商内容">
              <template v-slot="{data}">
                {{data.text}}
              </template>
            </c-table-column>
          </c-table>
        </div>
      </div>

      <module name="诉求及处理">
        <div style="width:100%;margin-left: -15px;">
          <c-detail title="用户诉求" width="100%" >
            <c-detail-item label="申请人">
              {{disputeInfo.nick_name}} -{{disputeInfo.user_manage_mobilephone}}
            </c-detail-item>
            <c-detail-item label="申请时间">
              {{disputeInfo.create_date}}
            </c-detail-item>
            <c-detail-item label="申请原因">
              {{disputeInfo.claim}}
            </c-detail-item>
            <c-detail-item label="附件">
              <c-image
                  v-if="disputeInfo.attachmentList"
                  v-for="(item,j) in disputeInfo.attachmentList"
                  :key="j"
                  :src="item.file_url"
                  size="50"
                  preview
              ></c-image>
            </c-detail-item>
          </c-detail>

          <c-detail title="平台处理"  v-if="disputeInfo.state==2">
            <c-detail-item label="处理人">
              {{disputeInfo.plat_process_user}}
            </c-detail-item>
            <c-detail-item label="处理时间">
              {{disputeInfo.plat_process_date}}
            </c-detail-item>
            <c-detail-item label="处理意见">
              {{disputeInfo.plat_process_notes}}
            </c-detail-item>
            <c-detail-item label="处理结果" v-if="disputeInfo.plat_process_refund_number">
              给用户退款￥{{parseFloat(disputeInfo.refund_total_money).toFixed(2)}}，详见退款单号：{{disputeInfo.plat_process_refund_number}}
            </c-detail-item>
            <c-detail-item label="处理结果" v-else>
              无退款
            </c-detail-item>
          </c-detail>
        </div>
      </module>

      <template slot="button" >
          <c-button v-if="disputeInfo.state==1" size="m" power="b_dispute_process"  @click="viewProcessDispute" color="main">处理</c-button>
          <c-button size="m" power="b_dispute_process"  @click="viewChatRecords">查看聊天记录</c-button>
      </template>

    </module>


    <!-- 在现有模板中的按钮后面添加对话框!-->
      <c-dialog ref="chatDialog"
      title="群聊天记录"
      width="600"
      height="500"
      :close-button="true"
      >
        <div v-if="!chatRecords.length" class="chat-empty flex-center">
          暂无聊天记录
        </div>
        <div v-else ref="chatList" class="chat-list" @scroll="chatScrollHandle">
			<div v-for="(item, i) in chatRecords" :key="i" class="chat-item flex">
				<div class="chat-icon flex-center">
					<img :src="item.avatar">
				</div>
				<div class="flex-grow">
                    <div class="flex-between-center" style="margin-bottom: 10px;">
                        <p class="chat-name">{{item.nick}} </p>
						<div v-if="item.user_type" class="chat-tag" :style="{'background': memberDict[item.user_type][1]}">{{memberDict[item.user_type][0]}}</div>
                        <p class="chat-time flex-grow">{{item.time}}</p>
					</div>
					<div v-if="item.type == 'text'" class="chat-text">{{item.content}}</div>
					<div v-else-if="item.type == 'image'" class="chat-image flex-center" :style="{'height': `${Math.min(300, 200 / item.params.width * item.params.height)}px`}" @click="$preview({src: item.content})">
						<img :src="item.content" alt="">
					</div>
					<div v-else-if="item.type == 'product'" class="chat-card flex-center">
						<div class="chat-card-image flex-center">
							<img :src="item.params.image" alt="">
						</div>
						<div class="chat-card-info flex-grow flex-column">
							<p class="chat-card-name ellipsis-2 flex-grow">{{item.params.name}}</p>
							<span class="chat-card-sum">￥{{item.params.sum}}</span>
						</div>
					</div>
					<div v-else-if="item.type == 'order'" class="chat-card flex-center">
						<div class="chat-card-image flex-center">
							<img :src="item.params.image" alt="">
						</div>
						<div class="chat-card-info flex-grow flex-column">
							<p class="chat-card-name ellipsis-2 flex-grow">{{item.params.name}}</p>
							<div class="chat-card-sum flex-baseline">
								<span class="chat-card-sum-label">订单金额：</span>
								<span>￥{{item.params.sum}}</span>
							</div>
						</div>
					</div>
					<div v-else-if="item.type == 'refund'" class="chat-card flex-center">
						<div class="chat-card-image flex-center">
							<img :src="item.params.image" alt="">
						</div>
						<div class="chat-card-info flex-grow flex-column">
							<p class="chat-card-name ellipsis-2 flex-grow">{{item.params.name}}</p>
							<div class="chat-card-sum flex-baseline">
								<span class="chat-card-sum-label">退款金额：</span>
								<span>￥{{item.params.sum}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div ref="chatLoading"></div>
        </div>
    </c-dialog>

    <!-- 在现有模板中的按钮后面添加对话框!-->
    <c-dialog ref="processDialog"
              title="平台处理"
              width="600"
              height="auto"
              @resolve="processDispute"
              :close-button="true"
    >
          <c-form ref="disputeProcessForm">
            <c-form-item
              type="textarea"
            label="处理结果"
            name="process_notes"
            required
            word=""
            file-word=""
          ></c-form-item>

          <c-form-item
                  type="radio"
                  label="是否退款"
                  name="is_refund"
                  v-model="is_refund"
                  :options="[{ name: '不退款', value: 1 },{ name: '退款', value: 2 }]"
                  @change="handleRefundSwitch"
                  required
                  :word="is_refund?(is_refund==1?'不退款，此纠纷结束，不影响原有服务状态':'退款后，原有服务状态终止，订单结束'):''"
          ></c-form-item>

          <c-form-item
                  v-show="showRefundAmount"
                  type="number"
                  label="退款金额"
                  name="refund_money"
                  input-unit="元"
                  decimal="2"
                  :limit="[0,]"
                  required
          ></c-form-item>
      </c-form>
    </c-dialog>
  </page>
</template>

<script>


import {mapGetters} from "vuex";
import nodeList from "@/components/public/node_list.vue";
import productInfo from "@/components/public/product_info.vue";

export default {
  name: 'dispute_detail',

  props: {
    id: String
  },

  components: {
    productInfo,
    nodeList

  },

  data() {
    return {
      disputeInfo: '',
      attachmentList: [],
      orderInfo: {},
      refundInfo: {
          base_info: {
              refund_number: '',
          },
          order_info: {

          }
      },
      disputeStateName: {
        1: '待处理',
        2: '处理完成',
        3: '用户撤销'
      },
      userTypeName: {
        1: '平台会员',
        2: '爆款代理',
        3: '专业代理',
        4: '服务商',
        99: '平台'
      },
      refundStateName: {
        1: '待审核',
        2: '审核通过',
        3: '审核驳回',
        4: '用户撤销'
      },
      chatDialogVisible: false,
      chatRecords: [],
      showRefundAmount: false,
      is_refund:0,
      chatPaging: {
        index: 1,
        size: 50,
        loading: false,
        end: false
      },
      memberDict: {
        1: ['平台用户', '#FF6900'],
        2: ['私有商家', '#0284FF'],
        3: ['平台商家', '#0284FF'],
        4: ['爆款代理', '#00BE50'],
        5: ['专业代理', '#00BE50']
      }
    }
  },

  computed: {
      ...mapGetters({
        auth: 'power'
      }),
      orderState() {
        var msg = "";
        if (this.orderInfo.refunding_count > 0) {
          msg = "订单申请【未发退款】";
        } else if (this.orderInfo.returning_count > 0) {
          msg = "订单申请【已发退货】";
        } else if (this.orderInfo.order_state == 0) {
          msg = "订单待报价";
        } else if (this.orderInfo.order_state == 2 && this.orderInfo.order_type == 10 && this.orderInfo.receive_state == 0){
          msg = "待好友领取礼物";
        }  else {
          if (this.orderInfo.order_classify == 1) {
            var sendTip = '买家已付款，等待商家发货';
            if (this.orderInfo.order_type == 8) {//拼团
              if (this.orderInfo.group_achieve == 1) {//已经成团
                sendTip = '拼团活动已成团，等待商家发货';
              } else {
                sendTip = '拼团活动尚未成团，待成团后发货';
              }
            }
            msg = {
              1: this.orderInfo.check_state == 3 ? '审核不通过(' + this.orderInfo.reject_reason +')':'等待买家付款',
              2: this.orderInfo.check_state == 3 ? '审核不通过(' + this.orderInfo.reject_reason +')':'买家已付款，等待商家开始服务',
              3: '商家服务进行中',
              4: '已服务完成，待客户验收',
              5: '客户已验收，交易成功',
              6: this.orderInfo.check_state == 3 ? '审核不通过':'订单已取消'
            }[this.orderInfo.order_state];
          } else {
            var sendTip = '买家已付款，等待发放卡券';
            if (this.orderInfo.order_type == 8) {//拼团
              if (this.orderInfo.group_achieve == 1) {//已经成团
                sendTip = '拼团活动已成团，等待发放卡券';
              } else {
                sendTip = '拼团活动尚未成团，待成团后发放卡券';
              }
            }
            msg = {
              1: this.orderInfo.check_state == 3 ? '审核不通过(' + this.orderInfo.reject_reason +')':'等待买家付款',
              2: this.orderInfo.check_state == 3 ? '审核不通过(' + this.orderInfo.reject_reason +')':'买家已付款，等待商家开始服务',
              3: '商家服务进行中',
              4: '已服务完成，待客户验收',
              5: '客户已验收，交易成功',
              6: this.orderInfo.check_state == 3 ? '审核不通过':'订单已取消'
            }[this.orderInfo.order_state];
          }
        }
        return msg;
      },
      paymentTotal() {
        if (this.orderInfo.order_type == 7) {
          return this.orderInfo.payment_state == 3 ? (this.orderInfo.payment_money || 0).toFixed(2) : (this.orderInfo.product_money + this.orderInfo.product_price_money + this.orderInfo.logistics_money + this.orderInfo.total_fee_money).toFixed(2);
        } else {
          if(this.orderInfo.payment_state == 2 || this.orderInfo.payment_state == 3){
            return (this.orderInfo.payment_money || 0).toFixed(2);
          }else{
            return (this.orderInfo.product_money + this.orderInfo.logistics_money + this.orderInfo.total_fee_money).toFixed(2);
          }
        }
     },
  },

  watch: {
    id() {
      this.getDispostDetail();
    },
    is_refund: function (val) {
      if(val == 2){
        this.showRefundAmount = true;
      }else{
        this.showRefundAmount = false;
      }
    }
  },

  mounted() {
    this.getDispostDetail();
  },

  methods: {
    getDispostDetail() {
      this.request({
        url: '/dispute/detail',
        data: {
          dispute_id: this.id
        },
        loading: true,
        success: data => {
          this.disputeInfo = data;
          this.attachmentList = data.attachmentList;
          this.orderInfo = data.orderInfo;
          this.refundInfo = data.refundInfo;
        }
      });
    },
    // 添加查看聊天记录的方法
    viewChatRecords() {
      if (!this.orderInfo.group_id) {
        this.$message({
          text: '暂无聊天记录',  // 提示内容
          icon: 'fail'  // 图标（success：成功，fail：失败）
        });
        return;
      }
      this.$refs.chatDialog.open();
      this.loadChatRecords(true);
    },

    // 加载聊天记录
    loadChatRecords(init) {
      // 这里调用实际的API获取聊天记录
		if (this.chatPaging.end || this.chatPaging.loading) return;
		this.chatPaging.loading = true;
      this.request({
        url: '/tim/group_chat_history',
        data: {
          group_id: this.orderInfo.group_id,
		  sort_type: 'asc',
		  index: this.chatPaging.index++,
		  pageSize: this.chatPaging.size,
        },
        loading: init,
        success: data => {
			this.chatPaging.loading = false;
			this.chatPaging.end = data.length < this.chatPaging.size;
			this.chatRecords = this.chatRecords.concat(
				data.map(item => {
					let payload = {};
					try {
						payload = JSON.parse(item.msg_body)[0].MsgContent;
					} catch(e) {}
					
					return {
						from: item.from_account,
                        user_type: item.user_type,
						avatar: item.head_photo,
						nick: item.nick_name,
						time: item.msg_time,
						content: payload.Data,
						type: payload.Desc,
						params: JSON.parse(payload.Ext || '{}')
					}
				}).filter(item => item.type)
			);
        }
      });
    },
	chatScrollHandle() {
		if (this.$refs.chatLoading.getBoundingClientRect().top < this.$refs.chatList.getBoundingClientRect().bottom + this.$refs.chatList.getBoundingClientRect().height * 0.5) {
			this.loadChatRecords();
		}
	},
    // 添加平台处理的方法
    viewProcessDispute() {
      this.$refs.disputeProcessForm.clear() ;
      this.$refs.processDialog.open();
    },
    // 平台处理
      processDispute(stop){
          stop();
          let data = this.$refs.disputeProcessForm.serialize();
          data.dispute_id = this.disputeInfo.id;

          if(!data.process_notes){
              this.$message({
                  text: '请填写处理结果',
                  icon: 'fail'
              });
              return;
          }

          // 如果选择了退款但未填写金额
          if(this.showRefundAmount && !data.refund_money){
              this.$message({
                  text: '请填写退款金额',
                  icon: 'fail'
              });
              return;
          }

          // 如果未选择退款，删除退款金额字段
          if(!this.showRefundAmount) {
               data.refund_money=0;
          }

          this.request({
              url: '/dispute/process',
              data: data,
              loading: true,
              success: data => {
                  this.$message({
                      text: '平台处理成功',
                      icon: 'success'
                  });
                  this.$refs.processDialog.close();
                  this.getDispostDetail();
                  this.$bus.$emit('disputeList.update', {});
              },
          });
      },
      handleRefundSwitch() {
          let formData = this.$refs.disputeProcessForm.serialize();
          let value = formData.is_refund;
          this.$refs.disputeProcessForm.setData({ refund_money: '' });
          this.showRefundAmount = false;
          if( value==2){
              this.showRefundAmount = false;
          }
      },
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/theme'
.dispute {
  &-state {
    height: auto;
    min-height: 40px;
    padding: 20px 34px;
    font-size: 13px;
    color: #000;
    background: #FFD700;
    background-image: url('~@/assets/image/order_detail_state_bg.png');
    background-size: 100% auto;
    background-position: left bottom;
    background-repeat: no-repeat;

    h1 {
      font-size: 24px;
      margin-bottom: 10px;
    }
    .info-content {
      h5 {
        font-size: 14px;
        margin: 5px 0;
      }
    }
  }
  &-info {
    height: auto;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: stretch;

    .info-section {
      flex: 1;
      padding: 15px;

      h2 {
        font-size: 18px;
        margin-bottom: 15px;
        color: #333;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
      }

      .info-content {
        .info-item {
          display: flex;
          margin-bottom: 10px;

          label {
            font-weight: bold;
            width: 80px;
            color: #666;
          }

          span {
            flex: 1;
            color: #333;
          }
        }
      }

      .dt {
        border-left: 3px solid #000;
        padding-left: 5px;
        margin-top: 25px;
        margin-bottom: 10px;
        line-height: 18px;
        font-size: 16px;
        font-weight: bold;
      }
  }

    .order-info {
      border-right: 1px solid #eee;
      width: 100%;
      border: 1px solid #ddd;

      dt {
        height: 42px;
        border-bottom: 1px solid #ddd;
        padding: 0 12px 0 16px;

        p {
          font-size: 13px;
          font-weight: bold;
        }
      }

      dd {
        padding: 12px 25px 12px 18px;
      }

      &-item {
        padding: 6px 0;
        line-height: 20px;
        font-size: 12px;

        label {
          min-width: 5em;
          color: #666;
          text-align: right;
        }

        p {
          a {
            color: #003DD9;
          }
        }
      }
    }

    .refund-info {
      margin-left: 20px;
    }
  }
}
.order-total {
  height: 45px;
  padding: 0 16px;
  font-size: 13px;
  color: #000;
  background: #F7F8FA;

  span {
    theme-color(main);
  }

  b {
    font-size: 16px;
  }

}
</style>

<style lang="stylus" scoped>
.chat {
	&-empty {
	  height: 500px;
	  color: #999
	}
	
	&-list {
		height: 500px;
		overflow: auto;
	}
	
	&-item {
		gap: 12px;
		padding: 20px 0;
		margin: 0 20px;
		
		&:nth-child(n+2) {
			border-top: 1px solid #eee;
		}
	}
	
	&-icon {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		overflow: hidden;
		background: #fff;
	}
		
	&-name {
		line-height: 20px;
		font-size: 14px;
	}
		
	&-time {
		line-height: 20px;
		font-size: 12px;
		text-align: right;
		color: #666;
	}
	
	&-text {
		line-height: 22px;
		font-size: 14px;
		white-space: pre-wrap;
		word-break: break-all;
	}
	
	&-image {
		width: 200px;
		border-radius: 6px;
		overflow: hidden;
		cursor: pointer;

		img {
			width: 100%;
			max-height: none;
		}
	}
	
	&-card {
		gap: 10px;
		box-sizing: border-box;
		width: 300px;
		border-radius: 6px;
		padding: 10px;
		background: #F8F8F8;
		
		&-image {
			width: 96px;
			height: 75px;
			border-radius: 6px;
			background: #F5F5F5;
		}
		
		&-info {
			gap: 10px;
		}
	
		&-name {
			height: 40px;
			line-height: 20px;
			font-size: 13px;
			word-break: break-all;
			color: #1A2938;
		}
	
		&-sum {
			font-size: 15px;
			font-weight: 400;
			color: #FF6900;
			
			&-label {
				font-size: 13px;
				color: #999;
			}
		}
	}

    &-tag {
		border-radius: 4px;
		padding: 0 4px;
		margin-left: 8px;
		line-height: 18px;
		font-size: 12px;
		white-space: nowrap;
		color: #fff;
    }
}
</style>
